var a="$$material";export{a as default};
//# sourceMappingURL=identifier.js.map
